export default __webpack_public_path__ + "static/media/lisieux08.57652687.jpg";